<template>
  <div class="banner-box" style="margin-top: 68px;">
    <v-img height="500" :src="img"></v-img>
    <div
        class="banner-text"
    >
      <h2 class="primary--text">
        {{title}}
      </h2>
      <h4 dir="auto" class="w-50 text-center white--text">
       {{content}}
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutBanner",
  props:{
    title:String,
    content:String,
    img:String,
  }
}
</script>

<style scoped>
.banner-box{
  position: relative; height: 500px
}
.banner-text{
  position:absolute;top: 20px;width: 100%;
  height: 500px;display:flex; flex-direction: column;
  justify-content: center;align-items: center;
}
</style>